var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Modal, Form, FormContextConsumer } from "@atlassiansox/microscopekit";
import { ModalFooter } from "@atlaskit/modal-dialog";
import Button, { ButtonGroup } from "@atlaskit/button";
import AkSpinner from "@atlaskit/spinner";
export var FormModal = function (_a) {
    var actions = _a.actions, rest = __rest(_a, ["actions"]);
    return (React.createElement(Modal, __assign({}, rest, { actions: undefined, components: {
            Container: function (_a) {
                var children = _a.children, className = _a.className;
                return (React.createElement(Container, { onSubmit: actions.submit.onSubmit, className: className }, children));
            },
            Footer: function (_a) {
                var showKeyline = _a.showKeyline;
                return (React.createElement(Footer, __assign({}, rest, { showKeyline: showKeyline, actions: actions })));
            }
        } })));
};
var Container = function (_a) {
    var onSubmit = _a.onSubmit, className = _a.className, children = _a.children;
    return (React.createElement(Form, { onSubmit: onSubmit, className: className }, children));
};
var Footer = function (_a) {
    var showKeyline = _a.showKeyline, actions = _a.actions;
    return (React.createElement(ModalFooter, { showKeyline: showKeyline, style: { zIndex: "unset" } },
        React.createElement("span", null),
        React.createElement(ButtonGroup, null,
            actions.submit ? (React.createElement(FormButton, { appearance: "primary", type: "submit", isLoading: actions.submit.isSubmitting }, actions.submit.text)) : null,
            React.createElement(FormButton, { onClick: actions.close.onClose }, actions.close.text))));
};
var FormButton = function (_a) {
    var isLoading = _a.isLoading, type = _a.type, rest = __rest(_a, ["isLoading", "type"]);
    return (React.createElement(FormContextConsumer, null, function (_a) {
        var isSubmitting = _a.isSubmitting;
        var isSpinnerVisible = isLoading || isSubmitting;
        return (React.createElement(Button, __assign({}, rest, { type: type, iconBefore: isSpinnerVisible && type === "submit" ? (React.createElement(AkSpinner, { size: "small" })) : undefined, isDisabled: isSpinnerVisible })));
    }));
};
